import { Controller } from '@hotwired/stimulus';

export default class PricingTierController extends Controller {
  static targets = ['button'];
  static values = {
    url: String
  };

  toggle() {
    const buttonUrl = new URL(this.buttonTarget.href);
    const queryParams = new URLSearchParams(buttonUrl.search);
    let campaignValue = queryParams.get('campaign');
    if (event.target.dataset.workbook === 'true') {
      campaignValue += '_workbook';
    } else {
      campaignValue = campaignValue.replace('_workbook', '');
    }
    queryParams.set('plan', event.target.dataset.plan);
    queryParams.set('campaign', campaignValue);
    this.buttonTarget.href = `${this.urlValue}?${queryParams.toString()}`;
  }
}
